import React from "react";
import PropTypes from "prop-types";
import {AButton} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {postIncidentWorkflow} from "store/features/incidentResponseSlice";
import PlaybookNoteButton from "./PlaybookNoteButton";
import SelectEntityButton from "./SelectEntityButton";
import css from "./PlaybookStage.module.scss";

export default function PlaybookTaskButton({
  coa,
  openDrawer,
  setCoaId,
  setCoaTargetType,
  setWorkflowId,
  stage
}) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {external_references, open_c2_coa} = coa;
  const reference = external_references?.[0];
  const externalId = reference?.external_id;
  const hasWorkflow =
    reference?.source_name === "workflow" && externalId?.length > 0;

  const WorkflowButon = () => {
    const coaTargetType = open_c2_coa?.target?.type;

    const handleExecution = (e) => {
      e.stopPropagation();
      dispatch(
        postIncidentWorkflow({
          coaId: coa?.id,
          workflowId: externalId
        })
      );
    };

    return coaTargetType?.length > 0 ? (
      <SelectEntityButton
        className={css.actionButton}
        {...{
          coa,
          openDrawer,
          setCoaId,
          setCoaTargetType,
          setWorkflowId
        }}
      />
    ) : (
      <AButton
        secondary
        small
        className={css.actionButton}
        onClick={(e) => handleExecution(e)}>
        {t("response.execute")}
      </AButton>
    );
  };

  return hasWorkflow ? (
    <WorkflowButon />
  ) : (
    <PlaybookNoteButton className={css.actionButton} {...{coa, stage}} />
  );
}

PlaybookTaskButton.propTypes = {
  /**
   * COA data object
   */
  coa: PropTypes.object,
  /**
   * Function to open the drawer
   */
  openDrawer: PropTypes.func,
  /**
   * Function to set state for current COA ID
   */
  setCoaId: PropTypes.func,
  /**
   * Function to set state of current COA target.type
   */
  setCoaTargetType: PropTypes.func,
  /**
   * Function to set state of current workflow ID (external_id)
   */
  setWorkflowId: PropTypes.func,
  /**
   * Name of the current Playbook stage
   * @remark Used to pre-populate Note modal
   */
  stage: PropTypes.string
};
